module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/mzxz1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fmzxz1.png
// module id = 4joB
// module chunks = 93